import alertService from "../Services/alertService";

export const errorInterceptor = function (response) {
  if(response.status !== 200){
    alertService.setAlert("error", "Ops, qualcosa è andato storto")
  }
  else if(response.data && response.data.ok === false){
   if(response.data.exception){
      alertService.setAlert("error", response.data.errorMessage + '. ' + response.data.exception.Message);
   }else{
      alertService.setAlert("error", response.data.errorMessage + '. ');
   }
  }

  return response;
}





// WEBPACK FOOTER //
// ./src/util/axiosConfig.js